import { Pipe, PipeTransform } from '@angular/core';
// import { stringify } from 'querystring';
import { DomSanitizer  } from '@angular/platform-browser';
@Pipe({
    name: 'iconspipe',
    standalone: false
})
export class IconsPipe implements PipeTransform {
  constructor( private domSanitizer: DomSanitizer ){ }
  transform(caract: any): any {
    let resp: string;

    if (!caract.code){
      resp = '';
    }
    else if (caract.code === 'DORM'){

      resp =  `&lt;i role="button" class=" fas fa-bed" title="Dormitorios"  &gt ` + caract.cantidad + `&lt;/i&gt;`;
    }
    else if (caract.code === 'COC'){
      
      resp = `&lt;i role="button" class=" fas fa-sink" title="Cocinas"  &gt ` + caract.cantidad + `&lt;/i&gt;`;
    }
    else if  (caract.code === 'BAN'){

      resp =  `&lt;i role="button" class=" fas fa-bath" title="Cochera" &gt ` + caract.cantidad + `&lt;/i&gt;`;
    }
    else if  (caract.code === 'COCH'){

      resp =  `&lt;i role="button" class=" fas fa-car" title="Cochera" &gt ` + caract.cantidad + `&lt;/i&gt;`;
    }
    else if  (caract.code === 'SUPTOT'){

      resp =  `&lt;i role="button" class=" fas fa-ruler-combined" title="Medidas" &gt ` + caract.cantidad + `&lt;/i&gt;`;
    }
    else if  (caract.code === 'PILETA'){

      resp =  `&lt;i role="button" class="fas fa-swimming-pool" title="Pileta" &gt ` + caract.cantidad + `&lt;/i&gt;`;
    }
    else {

      resp =  `&lt;i role="button" class=""  &gt `  + `&lt;/i&gt;`;
    }
    
    return this.domSanitizer.bypassSecurityTrustHtml(new DOMParser().parseFromString(resp, 'text/html').documentElement.textContent);
  }

}
